import { GaragePage as GarageFeaturePage } from '@/features/garage/components/GaragePage';

export function GaragePage(): JSX.Element {
  return <GarageFeaturePage />;
}
